import { Routes } from '@angular/router';
//import { ComponentsComponent } from '../../components/components.component'

export const CommonLayout_ROUTES: Routes = [

    //Dashboard
    {
        path: '',
        loadChildren: () => import('../../dashboard/dashboard.module').then(m => m.DashboardModule),
    },

    //Apps
    {
        path: 'apps',
        loadChildren: () => import('../../apps/apps.module').then(m => m.AppsModule)  
    },/*
    {
        path: 'reports',
        loadChildren: () => import('../../reports/reports.module').then(m => m.ReportsModule)
    },*/
    //Component
   /* {
        path: 'demo',
        component: ComponentsComponent,
        children: [
            {
                path: '',
                redirectTo: '/components/affix',
                pathMatch: 'full'
            }, 
            {
                path: '',
                loadChildren: () => import('../../components/components.module').then(m => m.ComponentsModule)
            }
        ],
        data: {
            title: 'Components '
        }
    },

    //Pages
    {
        path: '',
        data: {
            title: 'Pages '
        },
        children: [
            {
                path: '',
                redirectTo: '',
                pathMatch: 'full'
            }, 
            {
                path: '',
                loadChildren: () => import('../../pages/pages.module').then(m => m.PagesModule)
            },
        ]    
    }    */
];